import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { localStorageService } from "./components/shared/localstorage.service";

export const authGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const _local = inject(localStorageService);
    if (await isAuthenticated()) {
        return true;
    } else {
        _local.customClearAllItems();
        router.navigate(['/login'], { queryParams: { returnUrl: state.url }, queryParamsHandling: 'merge' });
        return false;
    }
};

async function isAuthenticated() {
    const _local = new localStorageService();
    if (!_local.customGetItem('token') || _local.customGetItem('token') == null || _local.customGetItem('reset_password_token')) {
        return false;
    } else {
        return true;
    }
}